import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconVideo2"><Path d="M14.5 5C15.8807 5 17 6.11929 17 7.5V16.5C17 17.8807 15.8807 19 14.5 19H4.5C3.11929 19 2 17.8807 2 16.5V7.5C2 6.11929 3.11929 5 4.5 5H14.5Z" fill="currentColor"/><Path d="M20.915 6.54785C21.8966 6.17521 22.9473 6.90027 22.9473 7.9502V16.0498C22.9473 17.0997 21.8966 17.8248 20.915 17.4521L18.3223 16.4678L18 16.3447V7.65527L18.3223 7.53223L20.915 6.54785Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
